// @flow

import * as React from 'react';
import { observer } from 'mobx-react';
import { Row, Card, CardBody, Badge, Label, FormGroup, Table } from 'reactstrap';
import Analyse from '../../../../Model/Analyse';
import DataTableManyToOneEntry from '../../../../Components/DataTableManyToOneEntry';
import StringDataTableEntry from '../../../../Components/StringDataTableEntry';
import EntnahmeGefaess from '../../../../Model/EntnahmeGefaess';
import DataTableRow from '../../../../Components/DataTableRow';
import TagList from '../../../../Components/TagList';
import Lagerung from '../../../../Model/Lagerung';
import Methode from '../../../../Model/Methode';
import Probenstabilitaet from '../../../../Model/Probenstabilitaet';
import WysiwygPreview from '../../../../Components/WysiwygPreview';
import AnalyseLabor from '../../../../Model/AnalyseLabor';
import Labor from '../../../../Model/Labor';
import AnalyseMaterial from '../../../../Model/AnalyseMaterial';
import Material from '../../../../Model/Material';
import AnalyseVersand from '../../../../Model/AnalyseVersand';
import Versand from '../../../../Model/Versand';
import ReferenzwertTab from './ReferenzwertTab';
import AnalyseLaborEntry from './AnalyseLaborEntry';
import LaborUebermittlung from "../../../../Model/LaborUebermittlung";
import LaborFormular from "../../../../Model/LaborFormular";

type Props = {
  analyse: Analyse,
};

@observer
export default class BasicTab extends React.Component<Props, void> {
  render() {
    const { analyse } = this.props;

    return (
      <React.Fragment>
        <Table size="sm" striped style={{ marginTop: 8 }}>
          <tbody>
            <DataTableRow hide={!analyse.name} title={'Name'}>
              <StringDataTableEntry entity={analyse} field={'name'} trim />
            </DataTableRow>
            <DataTableRow hide={!analyse.uebermittlung || !analyse.uebermittlung.name} title={'Übermittlung'}>
              <DataTableManyToOneEntry
                  entity={analyse}
                  type={LaborUebermittlung}
                  field={'uebermittlung'}
              />
            </DataTableRow>
            <DataTableRow hide={analyse.labor.length <= 0} title={'Labor'}>
              {analyse.labor.map((l: AnalyseLabor, i: number) => (
                <AnalyseLaborEntry labor={l} />
              ))}
            </DataTableRow>
            <DataTableRow hide={!analyse.formular || !analyse.formular.name} title={'Formular'}>
              <DataTableManyToOneEntry
                  entity={analyse}
                  type={LaborFormular}
                  field={'formular'}
              />
            </DataTableRow>
            <DataTableRow hide={analyse.material.length <= 0} title={'Material'}>
              {analyse.material
                .map(
                  (m: AnalyseMaterial, i: number) =>
                    m.kommentar ? `${m.material.name} (${m.kommentar})` : m.material.name,
                )
                .join(', ')}
            </DataTableRow>
            <DataTableRow
              hide={!analyse.entnahmegefaess || !analyse.entnahmegefaess.name}
              title={'Entnahmegefäss'}
            >
              <DataTableManyToOneEntry
                entity={analyse}
                type={EntnahmeGefaess}
                field={'entnahmegefaess'}
              />
            </DataTableRow>
            <DataTableRow
              hide={!analyse.bildhinweise || analyse.bildhinweise.length <= 0}
              title={'Bildhinweise'}
            >
              <TagList entity={analyse} field={'bildhinweise'} url subField={'url'} />
            </DataTableRow>
            <DataTableRow hide={analyse.versand.length <= 0} title={'Versand'}>
              {analyse.versand
                .map(
                  (m: AnalyseVersand, i: number) =>
                    m.kommentar ? `${m.versand.name} (${m.kommentar})` : m.versand.name,
                )
                .join(', ')}
            </DataTableRow>
            <DataTableRow hide={!analyse.notfallanalyse} title={'Notfallanalyse'}>
              <StringDataTableEntry entity={analyse} field={'notfallanalyse'} />
            </DataTableRow>
            <DataTableRow hide={!analyse.frequenz} title={'Frequenz'}>
              <StringDataTableEntry entity={analyse} field={'frequenz'} />
            </DataTableRow>
            <DataTableRow hide={!analyse.methode || !analyse.methode.name} title={'Methode'}>
              <DataTableManyToOneEntry entity={analyse} type={Methode} field={'methode'} />
            </DataTableRow>
            <DataTableRow
              hide={!analyse.probenstabilitaet || !analyse.probenstabilitaet.name}
              title={'Probenstabilität'}
            >
              <DataTableManyToOneEntry
                entity={analyse}
                type={Probenstabilitaet}
                field={'probenstabilitaet'}
              />
            </DataTableRow>
            <DataTableRow hide={!analyse.lagerung || !analyse.lagerung.name} title={'Lagerung'}>
              <DataTableManyToOneEntry entity={analyse} type={Lagerung} field={'lagerung'} />
            </DataTableRow>
            <DataTableRow hide={!analyse.messungenauigkeit} title={'Impräzision'}>
              <StringDataTableEntry entity={analyse} field={'messungenauigkeit'} />
            </DataTableRow>
            <DataTableRow hide={!analyse.praeanalytik} title={'Präanalytik'}>
              <WysiwygPreview entity={analyse} field={'praeanalytik'} />
            </DataTableRow>
            <DataTableRow hide={!analyse.postanalytik} title={'Postanalytik'}>
              <WysiwygPreview entity={analyse} field={'postanalytik'} />
            </DataTableRow>
            <DataTableRow hide={!analyse.bemerkungen} title={'Bemerkungen'}>
              <WysiwygPreview entity={analyse} field={'bemerkungen'} />
            </DataTableRow>
            <DataTableRow hide={!analyse.hygienemassnahmen} title={'Hygienemassnahmen'}>
              <WysiwygPreview entity={analyse} field={'hygienemassnahmen'} />
            </DataTableRow>
            <DataTableRow hide={!analyse.meldepflicht} title={'Meldepflicht'}>
              <WysiwygPreview entity={analyse} field={'meldepflicht'} />
            </DataTableRow>
            <DataTableRow hide={!analyse.literatur} title={'Literatur'}>
              <WysiwygPreview entity={analyse} field={'literatur'} />
            </DataTableRow>
            <DataTableRow
              hide={!analyse.externe_links || analyse.externe_links.length <= 0}
              title={'Externe Links / Zusatzdokumente'}
            >
              <TagList entity={analyse} field={'externe_links'} url subField={'url'} additionalField={'name'} />
            </DataTableRow>
            <DataTableRow hide={!analyse.notizen} title={'Notizen'}>
              <WysiwygPreview entity={analyse} field={'notizen'} />
            </DataTableRow>
            <DataTableRow hide={!analyse.taxpunkte} title={'Taxpunkte'}>
              <StringDataTableEntry entity={analyse} field={'taxpunkte'} />
            </DataTableRow>
            <DataTableRow hide={!analyse.tags || analyse.tags.length === 0} title="Tags">
              <TagList entity={analyse} field="tags" subField="tag" />
            </DataTableRow>
            <DataTableRow hide={!analyse.aktualisierung_datum} title={'Aktualisierung'}>
              {analyse.aktualisierung_datum.format('DD.MM.YYYY')}
            </DataTableRow>
          </tbody>
        </Table>
        <div className="d-print-block">
          <ReferenzwertTab analyse={analyse} />
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/Views/Analysis/View/AnalyseForm/BasicTab.js